import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SwitchIconHorizontal = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 24 24" sx={{ height: '24px', width: '24px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M17 4V20M17 20L13 16M17 20L21 16M7 20V4M7 4L3 8M7 4L11 8"
        stroke="#14191F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default SwitchIconHorizontal;
